import React, { useEffect, useState } from 'react'
import { handleFind, jsonEstaVacio } from '../../helper/utils';
import InputDate from '../../components/modalComponents/InputDate';
import InputSelect from '../../components/modalComponents/InputSelect';
import InputSearchAsync from '../../components/modalComponents/InputSearchAsync';
import useDidMountEffect from '../../hooks/useDidMountEffect/useDidMountEffect';
import { useSubmitForm } from '../../hooks/useSubmitForm/useSubmitForm';
import { usePropsInputs } from '../../hooks/useProps/usePropsInput';
import { useGetOptionsSelect } from '../../hooks/useGetOptionsSelect/useGetOptionsSelect';
import {
  buscarColaboradorAllAPI, buscarColaboradorForReporteFaltasAPI,
  enviarReporteDeFaltasAPI, getAllDepartamentosRegionesAPI, getDepartamentosRegionesForFaltasReporteAPI,
} from '../../consumers/backendApisUrls';

const ReporteFaltas = () => {
  const SECTION_NAME = "ReporteFaltas";
  const KEYS = {
    IdEmpleado: "IdEmpleado",
    FechaInicio: "FechaInicio",
    FechaFin: "FechaFin",
    IdRegion: "IdRegion",
    ReporteFaltaFiltrarPorId: "ReporteFaltaFiltrarPorId"
  };

  const [typeSelected, setTypeSelected] = useState({});
  const [formValues, setFormValues] = useState({});
  const [allDropdowns, setAllDropdowns] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  const [submitForm] = useSubmitForm();
  const [getOptions] = useGetOptionsSelect();
  const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);

  const handleTypeSelect = ({ target }) => {
    setTypeSelected(target.value);
    setFormValues({});
  }

  const handleSendReport = async () => {
    setIsDownloading(true);
    const api = enviarReporteDeFaltasAPI();
    const payload = getPayload();
    try {
      await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, () => {});
    } catch (error) {
      console.error(error);
    } finally {
      setIsDownloading(false);
    }
  }

  const getPayload = () => {
    return {...formValues,
      ReporteFaltaFiltrarPorId: typeSelected?.value
    };
  }

  const getDropdowns = async () => {
    const api = getDepartamentosRegionesForFaltasReporteAPI();
    const departamentos = await getOptions(api);
    setAllDropdowns(departamentos);
  }

  useDidMountEffect(() => {
    if (typeSelected?.value === porRegion.value) {
      getDropdowns();
    }
  }, [typeSelected?.value])

  return (
    <div className='card-body'>
      <div id={SECTION_NAME}>
        <div className="col-sm-5">
          <InputSelect label='Selecciona un criterio de búsqueda' name='typeSelected' options={TYPES} direction='column' value={jsonEstaVacio(typeSelected) ? null : typeSelected} onChange={handleTypeSelect} sectionName={SECTION_NAME}/>  
        </div>

        {typeSelected?.value === porColaborador.value &&
          <DIV>
            <InputSearchAsync isRequired typeGet label="Nombre" api={buscarColaboradorForReporteFaltasAPI} {...commonProps(KEYS.IdEmpleado)}/>
          </DIV>
        }

        {typeSelected?.value === porFechaRegistro.value &&
          <DIV>
            <InputDate isRequired label="Desde" {...commonProps(KEYS.FechaInicio)}/>
            <InputDate isRequired label="Hasta" {...commonProps(KEYS.FechaFin)}/>
          </DIV>
        }

        {typeSelected?.value === porRegion.value &&
          <DIV>
            <InputSelect isRequired label="Región"
                         options={allDropdowns}
                         name={KEYS.IdRegion}
                         value={allDropdowns.find(o => o.value === formValues[KEYS.IdRegion])}
                         onChange={({ target }) => setFormValues(lastData => ({...lastData, [target.name]: target.value?.value}))} sectionName={SECTION_NAME} />
          </DIV>
        }

        <div className='col-sm-5'>
          <button className="btn btn-primary generic-button-ficha" onClick={handleSendReport} disabled={isDownloading}>
            {isDownloading ? 'Enviando Reporte ...' : 'Enviar via Gmail'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ReporteFaltas;

const porFechaRegistro = {value: 1, label: "Por Fecha Registro"};
const porRegion = {value: 2, label: "Por Región"};
const porColaborador = {value: 3, label: "Por Colaborador"};

const TYPES = [porFechaRegistro, porRegion, porColaborador]

const DIV = ({ children }) => (
  <div className='col-sm-5'>
    {children}
  </div>
)